import { MessageMention } from '@connect-x-app/shared-domain-models';

export const getArrayOfTextSplitByMention = (text: string | null | undefined, mentions: string[]): string[] => {
  if (!mentions.length) {
    return text ? [text] : [];
  }
  /**
   *  Sort to put the longest first so it correctly catches those first.
   *  There was a bug that if a shorter version of the mention was first in the text, it wouldn't catch the longer correctly
   *  Ex.: "@TEST" and "@TESTING"
   *  AVIO-46209
   */
  const mentionsPattern = mentions
    .map(role => `@${role.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}`)
    .sort((a, b) => b.length - a.length)
    .join('|');

  const mentionRegex = new RegExp(`(${mentionsPattern})\\s*`, 'g');
  return text?.split(mentionRegex) ?? [];
};

export const getMentionInProgressValue = (value: string): string => {
  if (value.startsWith('@')) {
    return value.substring(1);
  } else {
    return value;
  }
};

export const getMentionInProgress = (message: string, pattern: string, cursorPosition: number): string => {
  const isMentionInProgress = (word: string) => {
    return word.startsWith('@') && !new RegExp(pattern).test(word);
  };

  if (message) {
    const words = message.split(/\s+/);

    let startIndex = 0;
    const currentWord = words.find(word => {
      const indexOfCurrentWord = message.indexOf(word, startIndex);
      startIndex += word.length;
      return cursorPosition >= indexOfCurrentWord && cursorPosition <= indexOfCurrentWord + word.length;
    });

    if (currentWord && isMentionInProgress(currentWord)) {
      const startIndexOfWord = message.indexOf(currentWord, startIndex - currentWord.length);
      return message.substring(startIndexOfWord, cursorPosition);
    }
  }

  return '';
};

export const getMentionsRegex = (options: MessageMention[]) => {
  if (!options.length) {
    return 'a^';
  }
  return `@(${options
    .map(mention => `${mention.label.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}(?!\\w)`)
    .sort((a, b) => b.length - a.length) // Sort by length to match longest mentions first
    .join('|')})`;
};
